module.exports = __webpack_public_path__ + "img/coupon_list_bg_img.ec319c0a.png";